<template>
  <div class="table-flex-row" ref="header">
    <header-cell
      v-for="(item, k) in tableConfig"
      :key="`${k}_${item.name}`"
      :config-item="item"
      :data-cell = "k"
    />

    <div
      class="table-flex-row__control"
      v-for="(control, k) in headerControlPositions"
      :key="`header_control_${k}`"
      :data-control = "k"
      v-dragged="onControlDragged"
      :style="{left: `${control-5}px`}"
    ></div>

    <div
      class="table-flex-row__width-marker"
      ref="width_marker"
    ></div>
</div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue'
import VDragged from 'v-dragged'

import { mapGetters } from 'vuex'

import HeaderCell from './HeaderCell';

Vue.use(VDragged)

export default {
  components: {
    HeaderCell
  },

  props: {
    tableConfig: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      // This is params to handle d-n-d operations
      dragInProcess: false,
      startPos: null,
      leftBorder: null,
      rightBorder: null,
      deltaWidth: null,
      hoveredCell: null,
      percentToPx: 0
    }
  },

  computed: {
    ...mapGetters(['getWindowSize']),
    headerControlPositions() {
      let arr = []
      
      this.tableConfig.forEach( (item, i) => {
        if( !item.style.width ) return 

        let width = +item.style.width.slice(0, -1) * this.percentToPx

        if(i) {
          arr.push( width + arr[i-1] )
        } else {
          arr.push( width )
        }
      })

      return arr
    }
  },

  mounted() {
    this.$nextTick( function() {
      this.percentToPx = +this.$refs.header.offsetWidth/100      
    })
  },

  watch: {
    getWindowSize: function() {
      this.percentToPx = +this.$refs.header.offsetWidth/100
    }
  },

  methods: {
    resetDrag() {
      this.dragInProcess = false
    },
    onControlDragged({el, deltaX, deltaY, offsetX, offsetY, clientX, clientY, first, last}) { 
      if( first ) {
        let num = +el.dataset.control

        this.setBordersForWidth(num)

        this.$refs.width_marker.style.left = el.style.left
        this.$refs.width_marker.style.opacity = 1 
        this.resetDrag()
      }
      if(this.dragInProcess) return

      this.dragInProcess = true

      if( offsetX !== undefined ) {
        if(offsetX <= this.leftBorder) {
          this.deltaWidth = this.leftBorder
        } else if(offsetX >= (this.rightBorder - 5)) {
          this.deltaWidth = this.rightBorder
        } else {
          this.deltaWidth =  offsetX
        }
        this.$refs.width_marker.style.left = `${this.startPos + this.deltaWidth}px` 
      }

      if ( last ) {
        this.$store.dispatch('setNewColsWidth', {
          leftCol: this.tableConfig[+el.dataset.control].realNum,
          rightCol: this.tableConfig[+el.dataset.control + 1].realNum,
          deltaWidth: this.deltaWidth,
          totalWidth: +this.$refs.header.offsetWidth
        })
        this.$refs.width_marker.style.opacity = 0
        this.setBordersForWidth()       
      }
      setTimeout(this.resetDrag, 1)
    },
    setBordersForWidth( num ) {
      if( num !== undefined ){
        this.startPos =  this.headerControlPositions[num]
        if(num) {
          this.leftBorder = this.headerControlPositions[num-1] - this.startPos
          this.rightBorder = (num+1) === this.headerControlPositions.length? 
            this.$refs.header.offsetWidth - this.startPos:
            this.headerControlPositions[num+1] - this.startPos  
        } else {
          this.leftBorder = -this.startPos
          this.rightBorder = this.headerControlPositions[num+1] - this.startPos
        }
      } else {
        this.startPos = null
        this.leftBorder = null
        this.rightBorder = null
        this.deltaWidth = null
      }
    }
  }
};
</script>
